import { ReactNode, createContext, useContext } from 'react';

import { usePurchaseDetails } from './purchase-details.hook';

type PurchaseDetailsContext = ReturnType<typeof usePurchaseDetails>;

const PurchaseDetailsContext = createContext<PurchaseDetailsContext | null>(
    null,
);

export const PurchaseDetailsProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const purchaseDetails = usePurchaseDetails();

    return (
        <PurchaseDetailsContext.Provider value={purchaseDetails}>
            {children}
        </PurchaseDetailsContext.Provider>
    );
};

export const usePurchaseDetailsContext = () => {
    const context = useContext(PurchaseDetailsContext);

    if (!context) {
        throw new Error(
            'usePurchaseDetailsContext must be used within a PurchaseDetailsProvider',
        );
    }

    return context;
};
